import styled from 'styled-components';

export const StyledLandingFeedbacks = styled.div`
  .landing_feedbacks_description {}

  .landing_feedbacks_carousel-container {}
`;
